import api from "@/api";

export default {
    namespaced: true,

    state: {
        giveaway: {
            enabled: false,
            participates: false,
        },
        place_info: {
            place: {
                name: '',
            },
            question: ''
        },
        rateValue: null,
        rateUid: null,
    },

    getters: {
        getGiveaway(state) {
            return state.giveaway
        },
        getPlaceInfo(state) {
            return state.place_info
        },
        getRateValue(state) {
            return state.rateValue
        },
        getRateUid(state) {
            return state.rateUid
        },
    },
    mutations: {
        setGiveawayEnabled(state, value) {
            state.giveaway.enabled = value
        },
        setGiveawayParticipates(state, value) {
            state.giveaway.participates = value
        },
        setGiveawayDescription(state, value) {
            state.giveaway.description = value
        },
        setGiveawayTitle(state, value) {
            state.giveaway.giveaway_title = value
        },
        clearGiveaway(state) {
            state.giveaway.participates = false
        },
        setPlaceInfo(state, value) {
            state.place_info = value
        },
        setRateValue(state, value) {
            state.rateValue = value
        },
        setRateUid(state, value) {
            state.rateUid = value
        },
    },

    actions: {
        async sendRate(context, payload) {
            let url = `${payload.userStatus}?question_id=${payload.question_id}&rate=${payload.index}`;
            return await api.request("get", url);
        },

        async getRateInfo(context, question_id) {
            console.log('question_id', question_id)
            console.log('111111111111111:context.rootState.sessionToken', context.rootState.auth.accessToken)
            const url = context.rootState.auth.accessToken ? `/api/v1/questions/${question_id}` : `/api/questions/${question_id}`
            return await api.request("get", url);
        },

        async changeRate(context, {changeRateID, rate}) {
            var url = `/api/v1/changeRate?rate_id=${changeRateID}&rate=${rate}`;
            if (!localStorage.getItem('access_token')) {
                url = `/api/changeRateWithoutAuth?rate_id=${changeRateID}&rate=${rate}`;
            }
            return await api.request("get", url);
        },

        async sendSocialClick(context, payload) {
            var url = context.rootState.auth.accessToken ? `/api/v1/sendSocialClick` : `/api/sendSocialClickWithoutAuth`
            url += `?rate_id=${payload.rateUid}&link_id=${payload.linkUid}`;
            return await api.request("get", url);
        },

        async getPublicRateInfo(context, uid) {
            const url = `/api/publicRates/${uid}`
            return await api.request("get", url);
        },

        async copyVoteImagesTo(context, data) {
            const url = `/admin/votes/${data.source_vote_id}/images/copy`
            return await api.request("post", url, data);
        },
        async transferVoteDataTo(context, data) {
            const url = `/admin/votes/${data.source_vote_id}/data/copy`
            return await api.request("post", url, data);
        },
        async deleteVotes(context, data) {
            const url = `/admin/votes/delete`
            return await api.request("post", url, data);
        },
        async changeVotesPlace(context, data) {
            const url = `/admin/votes/place`
            return await api.request("put", url, data);
        },
        async changeVotesQuestion(context, data) {
            const url = `/admin/votes/question`
            return await api.request("put", url, data);
        },
        async editVoteComment(context, data) {
            const url = `/admin/votes/${data.vote_id}/comment`
            return await api.request("put", url, data);
        },
    }
};
